import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../lib/hook";
import { onGetAllAccounts } from "../../../lib/features/accounts/accounts.thunk";
import TitleBarComponent from "../../../components/titlebar/TitleBarComponent";
import { Button, Spin } from "antd";
import GroupButtonComponent from "./components/GroupButtonComponent";
import ButtonCreateAccount from "./button/ButtonCreateAccount";
import { listRoleAccount } from "../../../constant/listRoleAccount";

interface AccountsPageProps {
  // Add props here
}

const AccountsPage: React.FC<AccountsPageProps> = () => {
  const { isGot, accounts } = useAppSelector((store) => store?.accounts);
  const [loading, setLoading] = useState<boolean>(false);
  const dispatch = useAppDispatch();
  const handleGetListCustomer = async () => {
    setLoading(true);
    await dispatch(onGetAllAccounts());
    setLoading(false);
  };
  useEffect(() => {
    if (!isGot) {
      handleGetListCustomer();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div>
      <TitleBarComponent
        title="Tài khoản"
        reload={() => handleGetListCustomer()}
        actionButton={<ButtonCreateAccount />}
      />
      {loading ? (
        <div className="md:hidden flex flex-col gap-2 mt-3">
          <Spin tip="Đang tải...">
            <div className="rounded-md bg-white p-2 flex justify-between items-center">
              <div>
                <p className="font-medium text-base">
                  Văn Anh{" "}
                  <span className="text-xs text-gray-500">
                    ( Nguyễn Vân Anh )
                  </span>
                </p>
                <p className="font-medium text-xs line-clamp-2 text-gray-500 max-w-36">
                  123 Quận 6 TP.HCM
                </p>
              </div>
              <a
                href="/"
                className="inline-flex items-center justify-center bg-green-500 hover:bg-green-600 text-white font-medium h-10 w-10 rounded-full shadow transition-colors"
              >
                <i className="fa-solid fa-phone"></i>
              </a>
            </div>
            <div className="rounded-md bg-white p-2 flex justify-between items-center">
              <div>
                <p className="font-medium text-base">
                  Văn Anh{" "}
                  <span className="text-xs text-gray-500">
                    ( Nguyễn Vân Anh )
                  </span>
                </p>
                <p className="font-medium text-xs line-clamp-2 text-gray-500 max-w-36">
                  123 Quận 6 TP.HCM
                </p>
              </div>
              <a
                href="/"
                className="inline-flex items-center justify-center bg-green-500 hover:bg-green-600 text-white font-medium h-10 w-10 rounded-full shadow transition-colors"
              >
                <i className="fa-solid fa-phone"></i>
              </a>
            </div>
          </Spin>{" "}
        </div>
      ) : (
        <div className="md:hidden flex flex-col gap-2 mt-3">
          {accounts?.map((item, key) => (
            <div key={key} className="rounded-lg bg-white p-3 shadow-sm border">
              <div className="flex flex-col gap-2 text-gray-700">
                {/* Họ và tên */}
                <div className="flex justify-between items-center">
                  <p className="text-sm text-gray-500">Họ và tên</p>
                  <p className="font-medium text-right max-w-[65%] truncate">
                    {item?.fullName || "—"}
                  </p>
                </div>

                {/* Email */}
                <div className="flex justify-between items-center">
                  <p className="text-sm text-gray-500">Email</p>
                  <p className="font-medium text-right max-w-[65%] break-words">
                    {item?.email || "—"}
                  </p>
                </div>

                {/* Số điện thoại */}
                <div className="flex justify-between items-center">
                  <p className="text-sm text-gray-500">Số điện thoại</p>
                  <p className="font-medium text-right max-w-[65%]">
                    {item?.phone || "—"}
                  </p>
                </div>

                {/* Chức vụ */}
                <div className="flex justify-between items-center">
                  <p className="text-sm text-gray-500">Chức vụ</p>
                  {
                    listRoleAccount?.find((role) => role.value === item.role)
                      ?.tag
                  }
                </div>
              </div>
              <div className="flex justify-end mt-2">
                <GroupButtonComponent account={item} />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AccountsPage;
